import { supabase } from "@/integrations/supabase/client";
import { logger } from "./logger";

interface ErrorLog {
  message: string;
  stack?: string;
  componentStack?: string;
  userAgent?: string;
  url?: string;
  userId?: string;
}

export const logError = async (error: ErrorLog) => {
  try {
    // Get current user if available
    const { data: { user } } = await supabase.auth.getUser();
    
    // Log to console in development
    if (import.meta.env.DEV) {
      console.error('[Error Logger]', error);
    }

    // Store error in database for production monitoring
    const errorData = {
      ...error,
      userId: user?.id || error.userId,
      userAgent: navigator.userAgent,
      url: window.location.href,
      timestamp: new Date().toISOString()
    };

    // In production, you could send to your error tracking service
    // For now, we'll log to console and could extend to Supabase table
    if (!import.meta.env.DEV) {
      // Could add Supabase table insert here if needed
      console.error('[Production Error]', errorData);
    }

    return errorData;
  } catch (err) {
    // Don't let error logging break the app
    console.error('Failed to log error:', err);
  }
};

// Helper to track performance issues
export const logPerformance = (metric: string, duration: number) => {
  if (duration > 1000) { // Log slow operations (> 1 second)
    logger.warn(`[Performance] ${metric} took ${duration}ms`);
  }
};
